import popMsg from './popMsg';

/**
 * @description 在前端环境下，选取本地图片
 * @param {number} min 最少图片张数，默认0
 * @param {number} max 最多图片张数，默认1
 * @returns {Promise<{files: File[], urls: string[]} | false>} resolve值为对象，或reject false
 */
const selectPictureInFrontend = (() => {
  let min: number,
    max: number,
    form: HTMLInputElement,
    resolve: (value: unknown) => void,
    reject: (reason?: any) => void;
  return (_min = 0, _max = 1): Promise<{ files: File[]; urls: string[] } | false> => {
    min = _min;
    max = _max;
    return new Promise((_resolve, _reject) => {
      resolve = _resolve;
      reject = _reject;
      const existForm = document.querySelector('#upload-picture-form');
      if (!existForm) {
        form = document.createElement('input');
        form.setAttribute('type', 'file');
        form.setAttribute('accept', 'image/*');
        form.setAttribute('id', 'upload-picture-form');
        form.style.display = 'none';
        form.addEventListener('change', async function (this: { files: ArrayLike<File> }) {
          const files = Array.from(this.files);
          const fileNumber = files.length;
          if (!(min <= fileNumber && fileNumber <= max)) {
            if (min !== max) {
              popMsg(`选择图片的数量必须是${min}到${max}个`);
            } else {
              popMsg(`选择图片的数量必须是${min}个`);
            }
            reject(false);
            return;
          }
          const results = await Promise.all(
            files.map(
              file =>
                new Promise(resolve => {
                  const reader = new FileReader();
                  reader.addEventListener('load', function () {
                    resolve(reader.result);
                  });

                  if (file) {
                    reader.readAsDataURL(file);
                  }
                }),
            ),
          ).catch(() => {
            reject(false);
          });
          resolve({ files: files, urls: results });
        });
        document.body.appendChild(form);
      }
      if (max !== 1) {
        form.setAttribute('multiple', 'multiple');
      } else {
        form.removeAttribute('multiple');
      }
      form.click();
    });
  };
})();

export default selectPictureInFrontend;
